module.exports = __webpack_public_path__ + "img/benefits01-03.02b98cc.webp";